import type { PaymentDetailsType } from "@/types"
import { ColumnDef } from "@tanstack/react-table"

import { Button } from "@/components/ui/button"
import { Icons } from "@/components/icons"

import { DataTableColumnHeader } from "../../data-table"

export const paymentDetailsColumns: ColumnDef<PaymentDetailsType>[] = [
  {
    accessorKey: "consumer_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Consumer" />
    ),
    cell: ({ row }) => {
      const value = row.original.consumer_name
      return <div className="text-right md:py-0 md:text-left">{value}</div>
    },
  },
  {
    accessorKey: "consumer_address",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="justify-center"
        column={column}
        title="Address"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.consumer_address
      return (
        <div className="px-4 py-2 text-right md:py-0 md:text-left">{value}</div>
      )
    },
  },
  {
    accessorKey: "payment_date",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="justify-center"
        column={column}
        title="Date"
      />
    ),
    cell: ({ row }) => {
      const date = new Date(row.original.payment_date as string)
      const formattedDate = Intl.DateTimeFormat("en-US", {
        weekday: "short",
        month: "long",
        day: "numeric",
        year: "numeric",
      }).format(date)
      return (
        <div className="text-right md:py-0 md:text-left">{formattedDate}</div>
      )
    },
  },
  {
    accessorKey: "amount_paid",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="justify-center"
        column={column}
        title="Amount Paid"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.amount_paid
      return (
        <div className="flex justify-center">
          <span>{`₱${value}`}</span>
        </div>
      )
    },
  },
]
